// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import Security from '../_raw/ui/icon_security.svg';

export default withIconProps(Security);
